module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-windowdoor.svg?f6a2ef2f5f671aaf76cc228e0ec56804";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-windowdoor.svg
// module id = 1058
// module chunks = 1